export enum LogItemTitleItemType {
    Entity = 'author',
    String = 'string',
    Link = 'link',
    Icon = 'icon',
    Item = 'item',
    OptionEntity = 'optionEntity',
}
